var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-nav-item',{attrs:{"href":"#","right":""},on:{"click":function($event){return _vm.geoLocate()}}},[(_vm.showspinner)?_c('b-spinner',{attrs:{"small":""}}):_vm._e(),(!_vm.showspinner)?_c('font-awesome-icon',{attrs:{"icon":"crosshairs"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }